<template>
  <!-- eslint-disable -->
  <div class="d-flex flex-column">
    <!-- ZIP input decisions don't have comparison fields (Greater than, Less than, etc.) -->
    
    <div class="d-flex py-3">
      <v-checkbox
        class="message-item__settings--human"
        :label="'Display user answer'"
        v-model="node.displayUserAnswer"
        color="primary"
        hide-details="auto">
      </v-checkbox>
      <info-tooltip :info="'A human type message will be inserted once user Confirms the decision'"> </info-tooltip>
    </div>

    <va-array-input
      class="ringba-tags-input"
      v-slot="props"
      v-model="node.ringbaTags"
      :label="'Ringba tags'"
      :add-button-text="'Add tag'"
      :block-label="'Ringba tag'"
      column-layout-without-drag
      allow-empty>
      <div class="d-flex mt-3">
        <v-text-field
          class="panzoom-ignore flex-1 mr-1"
          :label="'Tag'"
          :placeholder="'Tag'"
          persistent-placeholder
          v-model="node.ringbaTags[props.index].tag"
          @input="tagChange(props.index, $event)" />

        <v-select
          :disabled="!node.ringbaTags[props.index].tag"
          :label="'Value'"
          v-model="node.ringbaTags[props.index].value"
          class="panzoom-ignore flex-1 ml-1"
          hide-details
          :items="RINGBA_TAG_VALUES"
          attach
          :menu-props="{
            offsetOverflow: true,
            offsetY: true,
          }">
        </v-select>
      </div>
    </va-array-input>
  </div>
</template>

<script>
  import { RINGBA_TAG_VALUES } from "./constant";
  import InfoTooltip from "@/components/custom/InfoTooltip.vue";
  /* eslint-disable */
  export default {
    name: "LiveChatZipDecision",
    components: {
      InfoTooltip,
    },
    props: {
      node: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        RINGBA_TAG_VALUES,
      };
    },
    methods: {
      tagChange(index, value) {
        if (!value) {
          this.node.ringbaTags[index].value = null;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";

  .ringba-tags-input {
    &::v-deep {
      .btn-custom-add {
        margin-top: 25px;
        
        // Hide duplicate add button
        &:nth-of-type(n+2) {
          display: none !important;
        }
      }
      .column-layout-without-drag {
        & > div {
          &:not(:first-child) {
            border-top: 1px dashed get-color("primary-65");
            margin-top: 20px;
            padding-top: 20px;
          }
          &:last-of-type {
            border-bottom: 1px dashed get-color("primary-65");
            padding-bottom: 20px;
          }
        }
      }
    }
  }
</style>
